"use client";

import React, { type ReactNode } from "react";
import NextLink from "next/link";
import { trackEvent } from "@/lib/analytics";

type UseCaseCtaLinkProps = {
  analyticsLanding?: "pt_ai_market_research";
  placement: "hero" | "final";
  className: string;
  children: ReactNode;
};

export default function UseCaseCtaLink({
  analyticsLanding,
  placement,
  className,
  children,
}: UseCaseCtaLinkProps) {
  return (
    <NextLink
      href="/#console"
      className={className}
      onClick={() => {
        if (!analyticsLanding) {
          return;
        }

        trackEvent("mirofish_ad_landing_cta_click", {
          landing_page: analyticsLanding,
          placement,
          destination: "/#console",
          locale: "pt",
        });
      }}
    >
      {children}
    </NextLink>
  );
}
